import { useCallback, useEffect, useRef } from 'react';
import { getChatSocketClient } from './getChatSocketClient';

export function useChatListSubscribe(chatIds: number[], enabled = true, isListReady = false) {
  const listIdsSignature = chatIds.join(',');

  const chatIdsRef = useRef(chatIds);
  const isListReadyRef = useRef(isListReady);

  useEffect(() => {
    chatIdsRef.current = chatIds;
    isListReadyRef.current = isListReady;
  });

  const subscribeList = useCallback(async (ids: number[], reason: string) => {
    try {
      await getChatSocketClient().subscribeChatList(ids);
      console.log('[ChatSocket] chat-list:subscribe', { chatIds: ids, reason });
    } catch (error) {
      console.error('[ChatSocket] chat-list:subscribe failed', { chatIds: ids, reason }, error);
    }
  }, []);

  useEffect(() => {
    if (!enabled || !isListReady) {
      return;
    }

    void subscribeList(chatIdsRef.current, 'list sync');
  }, [enabled, isListReady, listIdsSignature, subscribeList]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    try {
      getChatSocketClient().connect();
    } catch (error) {
      console.error('[ChatSocket] chat-list connect failed', error);
      return;
    }

    const offReconnect = getChatSocketClient().onConnect(() => {
      if (!isListReadyRef.current) {
        return;
      }

      void subscribeList(chatIdsRef.current, 'socket reconnect');
    });

    return offReconnect;
  }, [enabled, subscribeList]);
}
